module.exports = __webpack_public_path__ + "media/newstyle/images/after-03-831a9d49e12bfc39e9fac5ba20fc1670.png";